import {css, Theme, useTheme} from "@emotion/react";

import {Checkbox} from "@pg-design/checkbox-module";
import {backgroundColor, borderRadius, calculateRemSize, flex, mb, mt, ph, pv, w100} from "@pg-design/helpers-css";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {form, IFormProps} from "@pg-mono/form";

import {ISearchFiltersFormValues} from "../reducers/property_configurator_reducer";
import {PropertyConfiguratorStep} from "../views/PropertyConfigurator";
import {ActionButtons} from "./ActionButtons";
import {BudgetSlider} from "./BudgetSlider";

interface IOwnProps {
    handleTabChange: (value: PropertyConfiguratorStep, prev?: boolean) => void;
}

interface IProps extends IFormProps<ISearchFiltersFormValues>, IOwnProps {}

export const BudgetTabC = (props: IProps) => {
    const theme = useTheme();

    const handleTabChange = (value: PropertyConfiguratorStep, prev?: boolean) => {
        props.handleTabChange(value, prev);
    };

    const loan = props.getFieldProps("loan");
    const aftermarket = props.getFieldProps("aftermarket");

    return (
        <>
            <Text variant="headline_4" mb="1.6rem">
                Budżet
            </Text>
            <Text variant="body_copy_1" mb="3.2rem">
                Przesuń suwak aby określić Twój budżet. Zwróć uwagę na ilość potencjalnych ofert, które w wybranych przez Ciebie parametrach mogą mieścić się w
                danym budżecie.
            </Text>
            <div css={grayInfo}>
                <InfoIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" fill={theme.colors.gray[700]} />
                <Text color={theme.colors.gray[700]} variant="info_txt_1">
                    Jeśli ilość ofert w danym budżecie jest dla Ciebie niesatysfakcjonująca, spróbuj rozszerzyć poszukiwania zwiększając promień wybranej
                    lokalizacji lub zmień niektóre parametry poszukiwanego mieszkania.
                </Text>
            </div>
            <BudgetSlider values={props.values} onChange={props.onChange} />
            <Text color={theme.colors.gray[700]} variant="body_copy_1">
                Dodatkowe informacje
            </Text>
            <div css={checkboxWrapper}>
                <div css={checkboxContainer}>
                    <Checkbox
                        labelContent="Pokaż oferty z możliwością kredytowania"
                        id="loan"
                        name="loan"
                        checked={!!loan.value}
                        onChange={(_, checked) => loan.onChange(loan.name, checked)}
                    />
                </div>
                <div css={checkboxContainer}>
                    <Checkbox
                        labelContent="Interesują mnie również oferty z rynku wtórnego"
                        id="aftermarket"
                        name="aftermarket"
                        checked={!!aftermarket.value}
                        onChange={(_, checked) => aftermarket.onChange(aftermarket.name, checked)}
                    />
                </div>
            </div>
            <ActionButtons
                handleTabChange={handleTabChange}
                nextTab={{
                    label: "Pokaż oferty",
                    value: PropertyConfiguratorStep.RESULTS
                }}
                prevTab={{
                    label: "Powróć",
                    value: PropertyConfiguratorStep.ROOMS
                }}
                currentTab={PropertyConfiguratorStep.BUDGET}
            />
        </>
    );
};

export const BudgetTab = form<ISearchFiltersFormValues, IProps>(BudgetTabC);

const grayInfo = css`
    ${flex("flex-start")};
    gap: ${calculateRemSize(1)};
    ${mb(4)};
`;

const checkboxWrapper = (theme: Theme) => css`
    ${w100};
    ${flex("center")};
    gap: ${calculateRemSize(1)};
    ${mt(2)};

    @media (max-width: ${theme.breakpoints.md}) {
        flex-direction: column;
    }
`;

const checkboxContainer = (theme: Theme) => css`
    ${w100};
    ${flex()};
    ${ph(1)};
    ${pv(1)};
    ${backgroundColor(theme.colors.gray[100])};
    ${borderRadius(1)};
    > div {
        ${w100};
    }
`;
import {css, Theme, useTheme} from "@emotion/react";

import {Checkbox} from "@pg-design/checkbox-module";
import {backgroundColor, borderRadius, calculateRemSize, flex, mb, mt, ph, pv, w100} from "@pg-design/helpers-css";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {form, IFormProps} from "@pg-mono/form";

import {ISearchFiltersFormValues} from "../reducers/property_configurator_reducer";
import {PropertyConfiguratorStep} from "../views/PropertyConfigurator";
import {ActionButtons} from "./ActionButtons";
import {BudgetSlider} from "./BudgetSlider";

interface IOwnProps {
    handleTabChange: (value: PropertyConfiguratorStep, prev?: boolean) => void;
}

interface IProps extends IFormProps<ISearchFiltersFormValues>, IOwnProps {}

export const BudgetTabC = (props: IProps) => {
    const theme = useTheme();

    const handleTabChange = (value: PropertyConfiguratorStep, prev?: boolean) => {
        props.handleTabChange(value, prev);
    };

    const loan = props.getFieldProps("loan");
    const aftermarket = props.getFieldProps("aftermarket");

    return (
        <>
            <Text variant="headline_4" mb="1.6rem">
                Budżet
            </Text>
            <Text variant="body_copy_1" mb="3.2rem">
                Przesuń suwak aby określić Twój budżet. Zwróć uwagę na ilość potencjalnych ofert, które w wybranych przez Ciebie parametrach mogą mieścić się w
                danym budżecie.
            </Text>
            <div css={grayInfo}>
                <InfoIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" fill={theme.colors.gray[700]} />
                <Text color={theme.colors.gray[700]} variant="info_txt_1">
                    Jeśli ilość ofert w danym budżecie jest dla Ciebie niesatysfakcjonująca, spróbuj rozszerzyć poszukiwania zwiększając promień wybranej
                    lokalizacji lub zmień niektóre parametry poszukiwanego mieszkania.
                </Text>
            </div>
            <BudgetSlider values={props.values} onChange={props.onChange} />
            <Text color={theme.colors.gray[700]} variant="body_copy_1">
                Dodatkowe informacje
            </Text>
            <div css={checkboxWrapper}>
                <div css={checkboxContainer}>
                    <Checkbox
                        labelContent="Pokaż oferty z możliwością kredytowania"
                        id="loan"
                        name="loan"
                        checked={!!loan.value}
                        onChange={(_, checked) => loan.onChange(loan.name, checked)}
                    />
                </div>
                <div css={checkboxContainer}>
                    <Checkbox
                        labelContent="Interesują mnie również oferty z rynku wtórnego"
                        id="aftermarket"
                        name="aftermarket"
                        checked={!!aftermarket.value}
                        onChange={(_, checked) => aftermarket.onChange(aftermarket.name, checked)}
                    />
                </div>
            </div>
            <ActionButtons
                handleTabChange={handleTabChange}
                nextTab={{
                    label: "Pokaż oferty",
                    value: PropertyConfiguratorStep.RESULTS
                }}
                prevTab={{
                    label: "Powróć",
                    value: PropertyConfiguratorStep.ROOMS
                }}
                currentTab={PropertyConfiguratorStep.BUDGET}
            />
        </>
    );
};

export const BudgetTab = form<ISearchFiltersFormValues, IProps>(BudgetTabC);

const grayInfo = css`
    ${flex("flex-start")};
    gap: ${calculateRemSize(1)};
    ${mb(4)};
`;

const checkboxWrapper = (theme: Theme) => css`
    ${w100};
    ${flex("center")};
    gap: ${calculateRemSize(1)};
    ${mt(2)};

    @media (max-width: ${theme.breakpoints.md}) {
        flex-direction: column;
    }
`;

const checkboxContainer = (theme: Theme) => css`
    ${w100};
    ${flex()};
    ${ph(1)};
    ${pv(1)};
    ${backgroundColor(theme.colors.gray[100])};
    ${borderRadius(1)};
    > div {
        ${w100};
    }
`;
